// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__2KCL9","head":"Table_head__1ckZl","col":"Table_col__2gYXF"};